import type { Transcript, TranscriptState } from "../types";
import { formatTimestamp, humaneError, speakerColorClass } from "./helpers";

interface TranscriptViewProps {
  transcript: Transcript | null;
  state: TranscriptState;
}

export function TranscriptView({ transcript, state }: TranscriptViewProps) {
  if (state === "processing") {
    return <p className="viewer-status">Transcribing… this can take a moment.</p>;
  }

  if (state === "failed") {
    return (
      <p className="viewer-status failed">
        Transcription failed: {transcript?.error ? humaneError(transcript.error) : "unknown error"}
      </p>
    );
  }

  if (!transcript) {
    return <p className="viewer-status">Loading transcript…</p>;
  }

  if (transcript.segments.length === 0) {
    return <p className="viewer-status">No speech detected.</p>;
  }

  // First-seen order fixes each speaker's color for the whole transcript.
  const order = new Map<string, number>();

  return (
    <div className="transcript-view">
      <div className="segments">
        {transcript.segments.map((s, i) => (
          <div className="segment" key={`${s.start}-${i}`}>
            <div className="gutter">
              <div className={`speaker ${speakerColorClass(s.speaker, order)}`}>
                {s.speaker ?? "Speaker"}
              </div>
              <div className="time">{formatTimestamp(s.start)}</div>
            </div>
            <div className="text">{s.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
